<template>
    <DCard
        :title="$t('settings_onecrm.title')"
        class="mb-3"
        padding
    >
        <DFormRow
            :label="$t('settings_onecrm.graphql_api_url')"
            is-required
            :error="form.errors.graphql_api_url"
        >
            <DInput
                id="graphql_api_url"
                v-model="form.graphql_api_url"
                :placeholder="$t('settings_onecrm.graphql_api_url')"
                maxlength="255"
            />
        </DFormRow>
        <DFormRow
            :label="$t('settings_onecrm.username')"
            is-required
            :error="form.errors.username"
        >
            <DInput
                id="username"
                v-model="form.username"
                :placeholder="$t('settings_onecrm.username')"
                maxlength="255"
            />
        </DFormRow>
        <DFormRow
            :label="$t('settings_onecrm.password')"
            is-required
            :error="form.errors.password"
        >
            <DInput
                id="password"
                v-model="form.password"
                type="password"
                :placeholder="$t('settings_onecrm.password')"
            />
        </DFormRow>
        <DFormRow
            :label="$t('settings_onecrm.token')"
            is-required
            :error="form.errors.token"
        >
            <DInput
                id="token"
                v-model="form.token"
                type="password"
                :placeholder="$t('settings_onecrm.token')"
            />
        </DFormRow>
        <DFormRow
            :label="$t('settings_onecrm.tenant')"
            is-required
            :error="form.errors.tenant"
        >
            <DInput
                id="tenant"
                v-model="form.tenant"
                :placeholder="$t('settings_onecrm.tenant')"
                maxlength="255"
            />
        </DFormRow>
        <DRow>
            <DCol sm="4" />
            <DCol sm="4">
                <div
                    v-show="connectionStatus === 'successful'"
                    class="green-text"
                >
                    {{ $t('common.connection_successful') }}
                </div>
                <div
                    v-show="connectionStatus === 'unsuccessful'"
                    class="red-text"
                >
                    {{ $t('common.connection_unsuccessful') }}
                </div>
            </DCol>
            <DCol
                sm="4"
                class="check-database-connection-btn"
            >
                <DButton
                    icon="lan-connect"
                    :label="$t('common.check_connection')"
                    :disabled="isInLoadingState"
                    @click="checkConnection"
                />
            </DCol>
        </DRow>
    </DCard>
    <DFormControls
        :dirty="form.isDirty"
        :disabled="connectionStatus !== 'successful'"
        @submit="submitForm"
    />
</template>

<script setup>
import axios from 'axios'
import { useForm } from '@inertiajs/vue3'
import { ref } from 'vue'

const props = defineProps({
    oneCrmSettings: {
        type: Object,
        default () {
            return {}
        }
    },
    errors: {
        type: Object,
        default () {
            return {}
        }
    }
})

const connectionStatus = ref(null)

const form = useForm({
    graphql_api_url: props.oneCrmSettings?.graphql_api_url ?? null,
    username: props.oneCrmSettings?.username ?? null,
    password: null,
    token: null,
    tenant: props.oneCrmSettings?.tenant ?? null
})

const checkConnection = function () {
    form.clearErrors()

    axios.post(route('settings.one-crm.check-connection', form))
        .then(function () {
            connectionStatus.value = 'successful'
        })
        .catch(function (error) {
            connectionStatus.value = 'unsuccessful'

            if (error.response && error.response.data && error.response.data.errors) {
                form.setError(error.response.data.errors)
            }
        })
}

const submitForm = () => {
    form.clearErrors()
    form.post(route('settings.one-crm.store'))
}
</script>

<style scoped lang="scss">
.check-database-connection-btn {
    text-align: right;
    padding-bottom: 25px;
}

.green-text {
    color: green;
}
.red-text {
    color: red;
}

</style>
